import axios from 'axios';
import { API_BASE_URL } from '../../src/config';

const client = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

const getDeptToken = () => localStorage.getItem('deptToken');

const token = getDeptToken();
if (token) {
  client.defaults.headers.common.Authorization = `Bearer ${token}`;
}

client.interceptors.request.use((config) => {
  const nextConfig = { ...config };
  nextConfig.headers = nextConfig.headers ?? {};

  const latestToken = getDeptToken();
  if (latestToken) {
    nextConfig.headers.Authorization = `Bearer ${latestToken}`;
  } else if (nextConfig.headers.Authorization) {
    delete nextConfig.headers.Authorization;
  }

  return nextConfig;
});

export default client;
